// extracted by mini-css-extract-plugin
export default {"PlayerRange":"style_PlayerRange__nYea9","Mini":"style_Mini__6zZ4o"};